const IMT_USED_PROVIDERS = 'imtComparisonUsedProviders'

export async function loadUsedProviders(): Promise<string[]> {
  if (import.meta.client) {
    const usedProviders = await storage.getValue<string[]>(IMT_USED_PROVIDERS)
    return usedProviders ?? []
  }
  return []
}

export async function saveUsedProviders(providers: string[]) {
  await storage.setValue(IMT_USED_PROVIDERS, providers)
}

export async function clearUsedProviders() {
  await storage.removeValue(IMT_USED_PROVIDERS)
}

export async function addUsedProvider(provider: string) {
  const usedProviders = await loadUsedProviders()
  if (!usedProviders.includes(provider)) {
    usedProviders.push(provider)
    await saveUsedProviders(usedProviders)
  }
}

export async function removeUsedProvider(provider: string) {
  const usedProviders = await loadUsedProviders()
  if (usedProviders.includes(provider)) {
    usedProviders.splice(usedProviders.indexOf(provider), 1)
    await saveUsedProviders(usedProviders)
  }
}
